import styled from "styled-components";
import Colors from "../../../../themes/Colors";

const CampaignCardHolder = styled.div`
  background: ${Colors.snow};
  border: 1px solid ${Colors.border};
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);

  .campaignCard__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .campaignCard__badges {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .campaignCard__pill {
    display: inline-flex;
    align-items: center;
    padding: 2px 10px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    border: 1px solid;
  }

  .campaignCard__edit {
    width: 30px;
    height: 30px;
    border: 1px solid ${Colors.primaryAccent};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${Colors.primaryAccent};
    cursor: pointer;
    flex-shrink: 0;
  }

  .campaignCard__titlebar {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }

  .campaignCard__titlebar .campaignCard__title {
    margin-bottom: 0;
  }

  .campaignCard__head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }

  .campaignCard__headtext {
    min-width: 0;
  }

  .campaignCard__title {
    font-size: 20px;
    font-weight: 700;
    color: ${Colors.textStrong};
    margin: 0 0 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .campaignCard__meta {
    font-size: 16px;
    color: ${Colors.textSecondary};
    margin: 0 0 6px;
  }

  .campaignCard__meta--category {
    font-style: italic;
  }

  .campaignCard__logo {
    width: 64px;
    height: 64px;
    flex-shrink: 0;
    border-radius: 8px;
    overflow: hidden;
  }

  .campaignCard__logo img,
  .campaignCard__logo video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .campaignCard__dates {
    display: flex;
    justify-content: space-between;
    margin: 4px 0;
  }

  .campaignCard__dates span {
    font-size: 16px;
    color: ${Colors.textStrong};
  }

  .campaignCard__dates small {
    display: block;
    font-size: 12px;
    color: ${Colors.textMuted};
    margin-bottom: 2px;
  }

  .campaignCard__usage {
    margin-top: 2px;
  }

  .campaignCard__usage-label {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    color: ${Colors.textSecondary};
    margin-bottom: 4px;
  }

  .campaignCard__budget {
    margin-top: 4px;
    padding: 12px 14px;
    background: ${Colors.extraLightPrimary || "#e9f4fd"};
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .campaignCard__budget-label {
    font-size: 13px;
    color: ${Colors.textSecondary};
  }

  .campaignCard__budget-value {
    font-size: 16px;
    font-weight: 700;
    color: ${Colors.primaryAccent};
  }

  .campaignCard__infoRows {
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin: 4px 0;
  }

  .campaignCard__infoRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 15px;
  }

  .campaignCard__infoRow span {
    color: ${Colors.textMuted};
  }

  .campaignCard__infoRow b {
    color: ${Colors.primaryAccent};
    font-weight: 700;
  }

  .campaignCard__actions {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 6px;
  }

  .campaignCard__actions .ant-btn {
    border-radius: 8px;
  }

  .campaignCard__actions .campaignCard__detail {
    color: ${Colors.primaryAccent};
    border-color: ${Colors.primaryAccent};
    padding: 0 20px;
  }
`;

export default CampaignCardHolder;
